import { MutableRefObject } from 'react';

export interface UploadingFile {
  isUploading: boolean;
  name: string;
  htmlInputFile: File;
  error?: any;
}

export interface SessionImagesProps {
  files: string[];
  setFiles: any;
  examSheetId: string;
  variant: 'blue' | 'green';
  isConfigured: boolean;
  abortController?: MutableRefObject<AbortController | null>;
}

export interface Error {
  info: string;
  code?: string; //check if needed
}

export enum UploadState {
  SUCCESS = 0,
  FILENAMEALREADYUSED = 1,
}

export interface UploadingFileWithOptions {
  isUploading: boolean;
  name: string;
  htmlInputFile?: File;
  file: any;
  error: any;
}

export interface SessionImagesFileUploadListProps {
  open: boolean;
  files: UploadingFileWithOptions[];
  refreshData: () => void;
  sheetId: string;
  onAbort?: () => void;
}
